module.exports = {
      id: "follow-facebook-usage",
      viewBox: "0 0 29 28",
      url: __webpack_public_path__ + "svg-sprite.svg#follow-facebook",
      toString: function () {
        return this.url;
      }
    }